import { Colors } from './tokens/ts/_colors';

export enum ChartSets {
  Multi = 'multi',
  Neutrals = 'neutrals',
  Greens = 'greens',
  Oranges = 'oranges',
  Blues = 'blues'
}

export const ColorSets = {
  avatars: Object.keys(Colors)
    .filter((k: string) => k.indexOf('100') === -1 && k.indexOf('200') === -1 && k.indexOf('0') > -1)
    .map((k) => (<any>Colors)[k]),
  charts: {
    [ChartSets.Multi]: [
      Colors.b600,
      Colors.o600,
      Colors.g600,
      Colors.n600,
    ],
    [ChartSets.Neutrals]: [
      Colors.n900,
      Colors.n800,
      Colors.n700,
      Colors.n600,
      Colors.n500,
      Colors.n400,
      Colors.n300,
    ],
    [ChartSets.Greens]: [
      Colors.g900,
      Colors.g800,
      Colors.g700,
      Colors.g600,
      Colors.g500,
      Colors.g400,
      Colors.g300,
    ],
    [ChartSets.Oranges]: [
      Colors.o900,
      Colors.o800,
      Colors.o700,
      Colors.o600,
      Colors.o500,
      Colors.o400,
      Colors.o300,
    ],
    [ChartSets.Blues]: [
      Colors.b900,
      Colors.b800,
      Colors.b700,
      Colors.b600,
      Colors.b500,
      Colors.b400,
      Colors.b300,
    ],
  },
};
